import { useEffect, useState } from "react";
import { Spinner } from "src/components";
import { getOrderFuidDetails } from "src/services/order-api";
import { useToast } from "src/hooks/useToast";
import { useDispatch } from "react-redux";
import { ordActions } from "src/context/order-slice";
import { useSelector } from "react-redux";
import { RootState } from "src/context/store";
import OrderInfoInvoiceCard from "./OrderInfoTabCards/OrderInfoInvoiceCard";
import { getOrderInvoiceAcknowledgementInfo, getOrderInvoiceCardInfo } from "../OrderDetailsTab/OrderHelper";
import InfiniteScroll from "react-infinite-scroll-component";

const OrderInfoInvoices = () => {
  const [isLoading, setIsLoading] = useState(false);
  const { OrderInvoiceDetails } = useSelector((state: RootState) => state.ord);
  const { toast } = useToast();
  const dispatch = useDispatch();
  const [hasMore, setHasMore] = useState(true);
  const [page, setPage] = useState(2);
  const limit = 10;

  const order_id_int = window.sessionStorage.getItem("order_id_int") ? Number(window.sessionStorage.getItem("order_id_int")) : null;

  const fetchMoreData = async () => {
    if (isLoading) return;
    const order_id_int = window.sessionStorage.getItem("order_id_int") ? Number(window.sessionStorage.getItem("order_id_int")) : null;

    try {
      setPage((prevPage) => prevPage + 1);

      // setIsLoading(true);
      const res = await getOrderFuidDetails(order_id_int, page, limit);

      if (!res?.data?.data || res?.data?.data?.length === 0) {
        setHasMore(false);
        // setIsLoading(false);
        return;
      }
      const uniqueNewData = res?.data?.data;

      if (uniqueNewData.length === 0) {
        setHasMore(false);
        // setIsLoading(false);
        return;
      }

      dispatch(ordActions.setOrderInvoiceDetails(OrderInvoiceDetails ? [...OrderInvoiceDetails, ...uniqueNewData] : uniqueNewData));
    } catch (error) {
      console.error("Error fetching more data:", error);
      toast({
        variant: "destructive",
        description: "Failed to load more invoices",
      });
      setHasMore(false);
    }
  };

  const fetchFuidDetails = async () => {
    setIsLoading(true);

    try {
      const res = await getOrderFuidDetails(order_id_int, 1, 10);
      toast({ description: "Invoice details fetched successfully", variant: "default" });
      dispatch(ordActions.setOrderInvoiceDetails(res?.data?.data));
    } catch (error: any) {
      console.log(error);
      toast(error?.response?.data?.message);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchFuidDetails();
  }, []);

  return (
    <div>
      {isLoading ? (
        <div className="flex justify-center items-center h-[50vh]">
          <Spinner />
        </div>
      ) : OrderInvoiceDetails?.length && OrderInvoiceDetails.length > 0 ? (
        <div
          id="scrollableDiv"
          className="h-[calc(100vh-250px)] overflow-auto overflow-y-scroll scrollbar-thin scrollbar-thumb-gray-300 scrollbar-track-gray-100"
        >
          <InfiniteScroll
            dataLength={OrderInvoiceDetails?.length}
            next={fetchMoreData}
            hasMore={hasMore}
            loader={
              <div className="flex justify-center py-4">
                <Spinner />
              </div>
            }
            scrollableTarget="scrollableDiv"
            endMessage={<div className="py-4 text-center text-gray-500">No more invoices to load</div>}
          >
            {OrderInvoiceDetails?.map((fuid: any, index: number) => (
              <OrderInfoInvoiceCard
                index={index}
                key={fuid?.attachment_order_lnk_id}
                fuid={fuid}
                summaryData={getOrderInvoiceCardInfo(fuid)}
                acknowledgementData={getOrderInvoiceAcknowledgementInfo(fuid)}
              />
            ))}
          </InfiniteScroll>
        </div>
      ) : (
        <h1 className="text-center text-gray-500 text-lg h-[50vh] flex items-center justify-center">No invoice found</h1>
      )}
    </div>
  );
};

export default OrderInfoInvoices;
